import React from 'react'
import { object } from 'prop-types'

import BaseTemplate from 'components/templates/BaseTemplate'

import Container from 'components/atoms/Container'

import { branch } from 'baobab-react/higher-order'
import storage from 'utils/storage'

import TestIframe from './TestIframe'

const TestDetail = ({ testDetail, currentUser }) => {
  const riddleLink = 'https://www.riddle.com'
  const isRiddleTest = testDetail.actionUrl.includes(riddleLink)
  if (currentUser && !currentUser.agreed_to_campus_terms && testDetail.action === 'iframe') {
    storage.set('vpMetaNotice', true)
    storage.set('tncGoBack', true)
  }
  return (
    <BaseTemplate useNewHeader>
      <div className="test-detail-page">
        <Container fluid={isRiddleTest}>
          <div className="test-detail-page__content">
            <TestIframe testName={testDetail.name} url={testDetail.actionUrl}/>
          </div>
        </Container>
      </div>
      <style jsx>
        {`
          .test-detail-page {
            background-color: #fff;
            padding-bottom: 120px;
            :global(&__desc) {
              font-size: 16px;
              color: #0c2846;
            }
          }
        `}
      </style>
    </BaseTemplate>
  )
}

TestDetail.propTypes = {
  testDetail: object,
}

export { TestDetail }

export default branch({
  testDetail: ['serverProps', 'testDetail'],
  currentUser: ['serverProps', 'currentUser'],
}, TestDetail)
